
(function () {
  var _instance = null;
  var _instancesBySectionId = {};
  class ProductComparePopup extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector('[data-pcp-overlay]');
      this.closeBtns = this.querySelectorAll('[data-pcp-close]');
      this.tabs = this.querySelectorAll('[data-pcp-tab]');
      this.stepPrevBtns = this.querySelectorAll('[data-pcp-step-prev]');
      this.stepNextBtns = this.querySelectorAll('[data-pcp-step-next]');
      this.edgePrevBtns = this.querySelectorAll('[data-pcp-edge-prev]');
      this.edgeNextBtns = this.querySelectorAll('[data-pcp-edge-next]');
      this.tabArrowsEl = this.querySelector('[data-pcp-tab-arrows]');
      this.stepArrowsEl = this.querySelector('[data-pcp-tab-step]');
      this.tabScrollEl = this.querySelector('[data-pcp-tabbar-scroll]');
      this._tabKeys = [];
      this._slideCount = 0;
      this._onKeyDown = this._handleKeyDown.bind(this);
      this._lastTrigger = null;
    }

    connectedCallback() {
      _instance = this;
      this._sectionId = this.getAttribute('data-section-id') || '';
      if (this._sectionId) _instancesBySectionId[this._sectionId] = this;

      this._tabKeys = Array.prototype.map.call(this.tabs, function (t) {
        return t.getAttribute('data-pcp-tab');
      });

      var tr = this.querySelector('[data-pcp-device-track]');
      this._slideCount = tr ? tr.querySelectorAll('.pcp__device-card-slide').length : 0;

      this.closeBtns.forEach(function (btn) {
        btn.addEventListener('click', this.close.bind(this));
      }.bind(this));

      if (this.overlay) {
        this.overlay.addEventListener('click', function (e) {
          if (e.target === this.overlay) this.close();
        }.bind(this));
      }

      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          this.switchTab(tab.getAttribute('data-pcp-tab'));
        }.bind(this));
      }.bind(this));

      this.querySelectorAll('[data-pcp-step-prev], [data-pcp-edge-prev]').forEach(
        function (btn) {
          btn.addEventListener(
            'click',
            function () {
              this._stepTab(-1);
            }.bind(this)
          );
        }.bind(this)
      );
      this.querySelectorAll('[data-pcp-step-next], [data-pcp-edge-next]').forEach(
        function (btn) {
          btn.addEventListener(
            'click',
            function () {
              this._stepTab(1);
            }.bind(this)
          );
        }.bind(this)
      );

      this._updateTabArrows();

      ProductComparePopup._bindGlobalTriggers();
    }

    disconnectedCallback() {
      if (this._sectionId && _instancesBySectionId[this._sectionId] === this) {
        delete _instancesBySectionId[this._sectionId];
      }
      if (_instance === this) _instance = null;
    }

    static _bindGlobalTriggers() {
      if (ProductComparePopup._globalBound) return;
      ProductComparePopup._globalBound = true;
      document.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-pcp-open]');
        if (!trigger) return;

        var targetSectionId = trigger.getAttribute('data-pcp-open');
        var targetInstance = null;

        if (targetSectionId) {
          targetInstance = _instancesBySectionId[targetSectionId] || null;
        }

        if (!targetInstance) {
          var ownerSection = trigger.closest('[data-section-id], [data-section]');
          if (ownerSection) {
            var ownerSectionId =
              ownerSection.getAttribute('data-section-id') || ownerSection.getAttribute('data-section');
            if (ownerSectionId) {
              targetInstance = _instancesBySectionId[ownerSectionId] || null;
            }
          }
        }

        if (!targetInstance) {
          targetInstance = _instance;
        }

        if (!targetInstance) return;

        e.preventDefault();
        targetInstance._lastTrigger = trigger;
        targetInstance.open();
      });
    }

    _getSlideIndex() {
      var vp = this.querySelector('.pcp__device-card-viewport');
      if (!vp) return 0;
      var raw = vp.style.getPropertyValue('--pcp-i');
      if (!raw || String(raw).trim() === '') {
        raw =
          typeof window.getComputedStyle === 'function'
            ? window.getComputedStyle(vp).getPropertyValue('--pcp-i')
            : '0';
      }
      var n = parseInt(String(raw).trim(), 10);
      return isNaN(n) ? 0 : n;
    }

    _tabBarIndexForKey(key) {
      for (var j = 0; j < this.tabs.length; j++) {
        if (this.tabs[j].getAttribute('data-pcp-tab') === key) return j;
      }
      return 0;
    }

    _setSlideIndex(idx) {
      var sc = this._slideCount;
      if (sc < 1) return;
      if (idx < 0) idx = 0;
      if (idx >= sc) idx = sc - 1;

      var idxStr = String(idx);
      var track = this.querySelector('[data-pcp-device-track]');
      var tabKey = '';
      if (track) {
        var slides = track.querySelectorAll('.pcp__device-card-slide');
        if (slides[idx]) tabKey = slides[idx].getAttribute('data-pcp-slide-tab') || '';
      }

      this.querySelectorAll('.pcp__device-card-viewport').forEach(function (viewport) {
        viewport.style.setProperty('--pcp-i', idxStr);
      });
      this.querySelectorAll('[data-pcp-device-track]').forEach(function (tr) {
        var slides = tr.querySelectorAll('.pcp__device-card-slide');
        for (var s = 0; s < slides.length; s++) {
          slides[s].setAttribute('aria-hidden', s === idx ? 'false' : 'true');
        }
      });

      this.tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-pcp-tab') === tabKey;
        tab.classList.toggle('pcp__tab--active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    _stepTab(delta) {
      var sc = this._slideCount;
      if (sc < 1) return;
      var idx = this._getSlideIndex();
      var next = idx + delta;
      if (next < 0 || next >= sc) return;
      this._setSlideIndex(next);
      this._updateTabArrows();
      var track = this.querySelector('[data-pcp-device-track]');
      var k = '';
      if (track) {
        var slides = track.querySelectorAll('.pcp__device-card-slide');
        if (slides[next]) k = slides[next].getAttribute('data-pcp-slide-tab') || '';
      }
      this._scrollActiveTabIntoView(this._tabBarIndexForKey(k));
    }

    _updateTabArrows() {
      var nTabs = this._tabKeys.length;
      var sc = this._slideCount;
      if (nTabs < 1) return;

      if (nTabs <= 1) {
        if (this.tabArrowsEl) this.tabArrowsEl.classList.add('pcp__tabbar-row--single-tab');
      } else {
        if (this.tabArrowsEl) this.tabArrowsEl.classList.remove('pcp__tabbar-row--single-tab');
      }

      if (nTabs <= 1 && sc <= 1) {
        if (this.stepArrowsEl) this.stepArrowsEl.classList.add('pcp__tab-step--hidden');
        this.stepPrevBtns.forEach(function (b) {
          b.disabled = true;
        });
        this.stepNextBtns.forEach(function (b) {
          b.disabled = true;
        });
        this.edgePrevBtns.forEach(function (b) {
          b.classList.add('pcp__tabbar-chev--hidden');
        });
        this.edgeNextBtns.forEach(function (b) {
          b.classList.add('pcp__tabbar-chev--hidden');
        });
        return;
      }

      if (this.stepArrowsEl) this.stepArrowsEl.classList.remove('pcp__tab-step--hidden');

      var idx = this._getSlideIndex();
      if (sc < 1) sc = 1;

      this.stepPrevBtns.forEach(function (b) {
        b.disabled = idx <= 0;
      });
      this.stepNextBtns.forEach(function (b) {
        b.disabled = idx >= sc - 1;
      });
      this.edgePrevBtns.forEach(function (b) {
        b.classList.toggle('pcp__tabbar-chev--hidden', idx <= 0);
      });
      this.edgeNextBtns.forEach(function (b) {
        b.classList.toggle('pcp__tabbar-chev--hidden', idx >= sc - 1);
      });
    }

    _scrollActiveTabIntoView(idx) {
      if (!this.tabScrollEl || !this.tabs[idx]) return;
      if (typeof window.matchMedia === 'function' && window.matchMedia('(min-width: 768px)').matches) {
        return;
      }
      try {
        this.tabs[idx].scrollIntoView({
          inline: 'nearest',
          block: 'nearest',
          behavior: 'smooth',
        });
      } catch (e) {
        this.tabs[idx].scrollIntoView(false);
      }
    }

    open() {
      if (!this.overlay || this.overlay.classList.contains('pcp--open')) return;
      this.overlay.classList.add('pcp--open');
      this.overlay.setAttribute('aria-hidden', 'false');
      ProductComparePopup._lockBodyScroll();
      document.addEventListener('keydown', this._onKeyDown);
      this._updateTabArrows();
      var firstClose = this.overlay.querySelector('[data-pcp-close]');
      if (firstClose) firstClose.focus();
    }

    close() {
      if (!this.overlay || !this.overlay.classList.contains('pcp--open')) return;
      this.overlay.classList.remove('pcp--open');
      this.overlay.setAttribute('aria-hidden', 'true');
      ProductComparePopup._unlockBodyScroll();
      document.removeEventListener('keydown', this._onKeyDown);
      if (this._lastTrigger) {
        this._lastTrigger.focus();
        this._lastTrigger = null;
      }
    }

    switchTab(key) {
      var track = this.querySelector('[data-pcp-device-track]');
      if (!track) return;
      var slides = track.querySelectorAll('.pcp__device-card-slide');
      var slideIdx = 0;
      for (var s = 0; s < slides.length; s++) {
        if (slides[s].getAttribute('data-pcp-slide-tab') === key) {
          slideIdx = s;
          break;
        }
      }

      this._setSlideIndex(slideIdx);

      var scroll = this.querySelector('.pcp__scroll');
      if (scroll) scroll.scrollTop = 0;

      this._updateTabArrows();
      this._scrollActiveTabIntoView(this._tabBarIndexForKey(key));
    }

    _handleKeyDown(e) {
      if (e.key === 'Escape') this.close();
    }
  }

  ProductComparePopup._globalBound = false;

  ProductComparePopup._lockBodyScroll = function () {
    var body = document.body;
    if (body.classList.contains('pcp-body-locked')) return;
    var scrollY = window.scrollY || window.pageYOffset || 0;

    body.dataset.pcpScrollY = String(scrollY);
    body.classList.add('pcp-body-locked');
    body.style.position = 'fixed';
    body.style.top = '-' + scrollY + 'px';
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
  };

  ProductComparePopup._unlockBodyScroll = function () {
    var body = document.body;
    if (!body.classList.contains('pcp-body-locked')) return;
    var scrollY = parseInt(body.dataset.pcpScrollY || '0', 10) || 0;

    body.classList.remove('pcp-body-locked');
    body.style.position = '';
    body.style.top = '';
    body.style.left = '';
    body.style.right = '';
    body.style.width = '';
    delete body.dataset.pcpScrollY;

    window.scrollTo(0, scrollY);
  };

  if (!customElements.get('product-compare-popup')) {
    customElements.define('product-compare-popup', ProductComparePopup);
  }
})();